/*
 * Copyright 2019 NEM
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Catapult REST API Reference
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.7.15
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */


import ApiClient from '../ApiClient';





/**
* The SourceDTO model module.
* @module model/SourceDTO
* @version 0.7.15
*/
export default class SourceDTO {
    /**
    * Constructs a new <code>SourceDTO</code>.
    * The transaction that triggered the receipt.
    * @alias module:model/SourceDTO
    * @class
    * @param primaryId {Number} The transaction index within the block.
    * @param secondaryId {Number} The transaction index inside within the aggregate transaction. If the transaction is not an inner transaction, then the secondary id is set to 0.
    */

    constructor(primaryId, secondaryId) {
        

        
        

        this['primaryId'] = primaryId;this['secondaryId'] = secondaryId;

        
    }

    /**
    * Constructs a <code>SourceDTO</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/SourceDTO} obj Optional instance to populate.
    * @return {module:model/SourceDTO} The populated <code>SourceDTO</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SourceDTO();

            
            
            

            if (data.hasOwnProperty('primaryId')) {
                obj['primaryId'] = ApiClient.convertToType(data['primaryId'], 'Number');
            }
            if (data.hasOwnProperty('secondaryId')) {
                obj['secondaryId'] = ApiClient.convertToType(data['secondaryId'], 'Number');
            }
        }
        return obj;
    }

    /**
    * The transaction index within the block.
    * @member {Number} primaryId
    */
    primaryId = undefined;
    /**
    * The transaction index inside within the aggregate transaction. If the transaction is not an inner transaction, then the secondary id is set to 0.
    * @member {Number} secondaryId
    */
    secondaryId = undefined;








}


